import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-font-text" }
const _hoisted_2 = ["data-heap"]
const _hoisted_3 = { class: "m-input__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_form_error = _resolveComponent("joy-form-error")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.location.title')), 1),
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.location.subtitle')) + " ", 1),
      _createElementVNode("a", {
        class: "open-bottom-sheet",
        "data-heap": _ctx.dataHeapTooltipID,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openBottomSheet && _ctx.openBottomSheet(...args)))
      }, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.location.help')), 9, _hoisted_2)
    ]),
    _createElementVNode("label", {
      class: _normalizeClass(["m-input c-autocomplete", {invalid: _ctx.hasError, active: _ctx.focus}]),
      "data-js": "m-input"
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.location.placeholder')), 1),
      _createElementVNode("input", {
        ref: "location",
        type: "text",
        autocomplete: "off",
        "data-testid": "location",
        onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitFocus && _ctx.emitFocus(...args))),
        onFocusout: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
      }, null, 544)
    ], 2),
    _withDirectives(_createVNode(_component_joy_form_error, {
      "no-html-error-text": _ctx.$msg('profile.creation.completion.wizard.details.location.error.mandatory')
    }, null, 8, ["no-html-error-text"]), [
      [_vShow, _ctx.hasError]
    ])
  ]))
}